<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="title header-tablepage">Print</h4>
      <div class="d-flex align-items-center">
        <b-form-checkbox
          class="mr-2"
          @change="handleFranchise"
          v-model="is_franchise"
          :value="1"
          :unchecked-value="0"
          >Franshies</b-form-checkbox
        >
        <p class="mr-2 mb-0">Date :</p>
        <InputDatePickerFilter
          class="mt-2 mr-2"
          name="repurchase-date-to"
          textFloat=""
          ref="repurchase-date-to"
          :min-datetime="$moment().format()"
          v-model="filter.date"
          @input="cacheDate"
        />
        <b-button variant="primary" @click="updatePrice()" class="mr-2"
          >Update</b-button
        >
        <p
          class="text-link text-gray text-underline mb-0 mr-2"
          @click="clearAll()"
        >
          Clear
        </p>

        <b-dropdown id="dropdown" right class="btn-mobile mr-2">
          <template #button-content>
            <span class="d-none d-md-inline-flex btn-text mr-1">Action</span>
          </template>

          <b-dropdown-item @click="openModalProductList(1)">
            สินค้า
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(2)">
            เอกสารรับเข้า STK
          </b-dropdown-item>

          <b-dropdown-item @click="openModalProductList(4)">
            เอกสาร Inventory Transfer
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(5)">
            เอกสาร Repair
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(6)">
            เอกสาร CN
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(7)">
            เอกสาร Franshies
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(8)">
            เอกสาร RRT
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(9)">
            เอกสาร Invoice
          </b-dropdown-item>
          <b-dropdown-item @click="openModalProductList(10)">
            เอกสาร Invoice Consignment
          </b-dropdown-item>
        </b-dropdown>

        <b-button class="btn-filter" @click="openModalPrint()">
          <font-awesome-icon icon="print" />
          Print</b-button
        >
      </div>
    </div>
    <div class="bg-white border-red p-3">
      <b-table
        striped
        responsive
        hover
        :busy="isBusy"
        :items="items"
        :fields="fields"
        class="table-main table-custom"
        show-empty
        empty-text="No matching records found"
      >
        <template v-slot:cell(product_image)="{ item }">
          <img :src="item.product_image" class="img-size" />
        </template>
        <template #cell(weight)="{ item }">
          <div v-if="item.weight">{{ item.weight | numeral("0,0.00") }}</div>
          <div v-else>-</div>
        </template>
        <template #cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }} บาท
        </template>
        <template #cell(sale_status)="{ item }">
          {{ item.sale_status || "-" }}
        </template>

        <template #cell(fg_code)="{ item }">
          {{ item.fg_code || "-" }}
        </template>

        <template #cell(size)="{ item }">
          {{ item.size || "-" }}
        </template>

        <template #cell(serial)="{ item }">
          {{ item.serial || "-" }}
        </template>
        <template #cell(netsuite_price)="{ item }"
          ><div v-if="item.netsuite_price">
            {{ item.netsuite_price | numeral("0,0.00") }} บาท
          </div>

          <div v-else>-</div>
        </template>
        <template #cell(netsuite_sale_status)="{ item }">
          {{ item.netsuite_sale_status || "-" }}
        </template>
        <template #cell(action)="{ item }">
          <font-awesome-icon
            icon="trash-alt"
            class="pointer text-danger"
            @click="deleteItem(item.id)"
          />
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </div>
    <ModalConfirm
      ref="confirmModal"
      :text="confirmMsg"
      @handler="confirmDelete"
    />
    <ModalProductList
      ref="modalProductList"
      @success="getList(1)"
      :TransferFormList="TransferFormList"
      :date="filter.date"
      :is_franchise="is_franchise"
    />
    <ModalPrint
      ref="modalPrint"
      :date="filter.date"
      :is_franchise="is_franchise"
    />
    <ModalProcess ref="modalProcess" />
  </div>
</template>
<script>
import ModalConfirm from "@/components/modal/ModalConfirm.vue";
import ModalProductList from "./components/ModalProductList.vue";
import ModalPrint from "./components/ModalPrint.vue";
import ModalProcess from "./components/ModalProcess.vue";
import { valHooks } from "jquery";

export default {
  props: {},
  components: { ModalConfirm, ModalProductList, ModalPrint, ModalProcess },
  name: "Inventory",
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "index", label: "ลำดับ" },
        { key: "product_image", label: "Image" },
        { key: "fg_code", label: "FG CODE" },
        { key: "barcode", label: "รหัสสินค้า" },
        { key: "sale_status", label: "Model Status" },
        { key: "serial", label: "Serial No." },

        { key: "size", label: "Sizes" },
        { key: "weight", label: "WGT" },
        { key: "price", label: "ราคา" },
        { key: "netsuite_price", label: "ราคา NetSuite" },
        { key: "netsuite_sale_status", label: "NetSuite Status" },
        { key: "price", label: "ราคา" },
        { key: "action", label: "Action" },
      ],
      items: [],
      filter: {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        page: 1,
        take: 10,
        search: "",
      },
      rows: 0,
      deleteId: null,
      confirmMsg: "",
      TransferFormList: [],
      is_franchise: 0,
    };
  },
  async created() {
    this.restoreDate();
  },
  async mounted() {
    await this.getList();
    await this.getTransferForm();
  },
  methods: {
    async getList(isUpdate, isfilterDate) {
      this.isBusy = true;

      await this.checkProgress();

      if (isUpdate) {
        await this.axios(`printtag/UpdateJson`);
        await new Promise((resolve) => setTimeout(resolve, 3000));

        const payload = { ...this.filter };
        const res = await this.axios.post(`/printtag/getlist`, payload);

        this.rows = res.data.detail.total_count;
        this.items = res.data.detail.detail.map((x, index) => ({
          ...x,
          index: index + 1 + this.filter.take * (this.filter.page - 1),
        }));

        await this.$bus.$emit("hideLoading");
        this.isBusy = false;
        // this.successAlert();
        return;
      }

      const payload = { ...this.filter };
      const res = await this.axios.post(`/printtag/getlist`, payload);

      this.rows = res.data.detail.total_count;
      this.items = res.data.detail.detail.map((x, index) => ({
        ...x,
        index: index + 1 + this.filter.take * (this.filter.page - 1),
      }));
      if (res.data.detail.is_franchise) {
        this.is_franchise = 1;
        await this.axios(`printtag/UpdateJson`);
      }

      await this.$bus.$emit("hideLoading");
      if (!this.filter.date) {
        this.filter.date = this.$moment()
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      }

      this.isBusy = false;
    },
    async getTransferForm() {
      const res = await this.axios(`/printtag/Document/List/0 `);
      this.TransferFormList = res.data.detail;
    },
    async handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.getList();
    },
    deleteItem(id) {
      this.confirmMsg = "Confirm Deletion?";
      this.$refs.confirmModal.show("delete");

      this.deleteId = id;
    },
    async checkProgress() {
      await new Promise((resolve) => setTimeout(resolve, 3000));

      const load = await this.axios(`/printtag/GetProcessProduct`);

      if (load.data.detail.is_procress === 1) {
        this.$refs.modalProcess.show();

        try {
          await this.$refs.modalProductList.pollProcess();
        } finally {
          await this.axios(`printtag/UpdateJson`);

          this.$refs.modalProcess.hide();
        }
      } else {
        await this.axios(`printtag/UpdateJson`);

        this.$refs.modalProcess.hide();
      }
    },
    async confirmDelete(val, type) {
      if (val && this.deleteId && type === "delete") {
        console.log(val, type);
        this.$bus.$emit("showLoading");
        const res = await this.axios.delete(
          `/printtag/delete/${this.deleteId}/${this.filter.user_guid}`
        );
        if (res.data.result) {
          await this.axios(`printtag/UpdateJson`);

          // this.successAlert();
          this.filter = {
            user_guid: this.$cookies.get("print_tag_admin_user_guid"),
            page: 1,
            take: 10,
            search: "",
          };
          this.deleteId = null;
          this.$bus.$emit("hideLoading");
          await this.getList();
        }
      } else if (val && type === "clear") {
        this.$bus.$emit("showLoading");

        const res = await this.axios.delete(
          `/printtag/clear/${this.filter.user_guid}`
        );
        await this.axios(`printtag/UpdateJson`);
        this.filter = {
          user_guid: this.$cookies.get("print_tag_admin_user_guid"),
          page: 1,
          take: 10,
          search: "",
        };
        this.$bus.$emit("hideLoading");
        await this.getList();
      }
    },
    openModalProductList(type) {
      this.$refs.modalProductList.show(type);
    },
    openModalPrint() {
      this.$refs.modalPrint.show();
    },
    async clearAll() {
      this.confirmMsg = "Confirm Deletion?";
      this.$refs.confirmModal.show("clear");
    },
    async handleFranchise(val) {
      this.is_franchise = val;
      const res = await this.axios.put(`PrintTag/SelectFranchise`, {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        is_franchise: this.is_franchise,
      });
      await this.axios(`printtag/UpdateJson`);
    },
    async updatePrice() {
      this.$bus.$emit("showLoading");
      await this.axios.post(`/PrintTag/UpdateNetsuiteProduct`, {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        date: this.filter.date,
      });
      this.$bus.$emit("hideLoading");
      await this.getList(1);
    },
    cacheDate(value) {
      if (value) {
        localStorage.setItem("print-date", value);
      } else {
        localStorage.removeItem("print-date");
      }
    },

    restoreDate() {
      const savedDate = localStorage.getItem("print-date");
      if (savedDate) {
        this.filter.date = savedDate;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.img-size {
  width: 50px;
  height: 50px;
}
</style>
